import { RECENT_OPENS_TITLES } from "@loot-os/api-contract";
import type { RecentOpensContent } from "@loot-os/design-system/templates/home/homeContent";
import { useBestOpens } from "../../shared/bestOpens.js";

/** The home page's "Fire pulls": the shopper's best recent opens. */
export function useRecentOpensContent(): RecentOpensContent {
  return { title: RECENT_OPENS_TITLES.home, opens: useBestOpens() };
}
